// extracted by mini-css-extract-plugin
export var accent = "_99-4";
export var add = "_99-j";
export var addIcon = "_99-k";
export var deleteIcon = "_99-i";
export var disabled = "_99-9";
export var ellipsis = "_99-f";
export var error = "_99-3";
export var form = "_99-5";
export var hideFocus = "_99-2";
export var icon = "_99-7";
export var input = "_99-e";
export var listItem = "_99-h";
export var mediumHeight = "_99-b";
export var noBorder = "_99-8";
export var noRadius = "_99-1";
export var shortHeight = "_99-a";
export var tallHeight = "_99-c";
export var textInput = "_99-0";
export var vertical = "_99-g";
export var veryTallHeight = "_99-d";
export var widget = "_99-6";